import React, { useState, useEffect } from "react";
import "./gallery.css";
import "./galleryMedia.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-video.css";
import { useSelector } from "react-redux";
import AOS from "aos";
import "aos/dist/aos.css";

export const Gallery = () => {
  const [visibleCount, setVisibleCount] = useState(9);

  const gallery = useSelector((state) => state.gallery.image.gallery);
  const videoList = Object.values(gallery.galleryVideos).map((video) => ({
    type: "video",
    url: video.src,
    thumbnail: video.thumbnail,
  }));

  const imageList = Object.values(gallery.galleryImages).map((url) => ({
    type: "image",
    url,
  }));

  const combinedMedia = [...imageList, ...videoList];
  const displayedMedia = combinedMedia.slice(0, visibleCount);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <div className="gallery-intro" data-aos="fade-up">
        <h1>
          Latest Event <span>Photo Highlights</span>
        </h1>
        <p data-aos="fade-up" data-aos-delay="300">
          The Daily Free Prasadam Donation ensures sacred food is prepared and
          distributed daily to all devotees as a divine blessing. Your support
          helps sustain this tradition and brings special blessings. Annadanam
          Donation provides free, nutritious meals to devotees and those in
          need, ensuring no one goes hungry.
          <span className="hidden">
            Your contribution supports cooking and distribution. E-Undiyal
            Donation allows digital offerings for temple poojas, maintenance,
            and festivals, ensuring seamless spiritual activities. Donate
            effortlessly via UPI, bank transfer, or online payments.
          </span>
          <br />
          தினசரி இலவச பிரசாதம் தானம் என்பது தெய்வீக ஆசீர்வாதமாக அனைத்து
          பக்தர்களுக்கும் புனித உணவு தயாரிக்கப்பட்டு தினமும் விநியோகிக்கப்படுவதை
          உறுதி செய்கிறது. உங்கள் ஆதரவு இந்த பாரம்பரியத்தை நிலைநிறுத்த உதவுகிறது
          மற்றும் சிறப்பு ஆசீர்வாதங்களை தருகிறது.
        </p>
      </div>

      <div className="thumbnails" data-aos="zoom-in-up">
        <LightGallery
          speed={500}
          plugins={[lgThumbnail, lgZoom, lgVideo]}
          elementClassNames="masonry-gallery"
        >
          {displayedMedia.map((media, index) => {
            const animationDelay = index * 100;
            if (media.type === "video") {
              return (
                <a
                  key={`video-${index}`}
                  data-lg-size="1280-720"
                  data-video={`{"source": [{"src":"${media.url}", "type":"video/mp4"}], "attributes": {"preload": false, "playsinline": true, "controls": true}}`}
                  data-sub-html="<h4>Video</h4>"
                  data-aos="fade-up"
                  data-aos-delay={animationDelay}
                >
                  <img
                    className="masonry-thumb"
                    src={media.thumbnail}
                    alt={`video-${index}`}
                  />
                </a>
              );
            } else {
              return (
                <a
                  href={media.url}
                  key={`image-${index}`}
                  data-aos="fade-up"
                  data-aos-delay={animationDelay}
                >
                  <img
                    className="masonry-thumb"
                    src={media.url}
                    alt={`image-${index}`}
                  />
                </a>
              );
            }
          })}
        </LightGallery>

        {visibleCount < combinedMedia.length ? (
          <>
            <div
              className="read-more-wrapper"
              data-aos-delay="300"
            >
              <button
                className="read-more-button"
                onClick={() =>
                  setVisibleCount((prev) =>
                    Math.min(prev + 10, combinedMedia.length)
                  )
                }
              >
                See More <FaChevronDown />
              </button>
            </div>
            <div className="fade-gradient" />
          </>
        ) : (
          <button
            className="read-more-button"
            onClick={() => setVisibleCount(9)}
            data-aos-delay="300"
          >
            See Less <FaChevronUp />
          </button>
        )}
      </div>

      <div className="deity-section">
        <div className="deity-title" data-aos="zoom-in">
          <h1>
            <span>Divine Deities</span> of Adhie
            <br /> Annan Temple
          </h1>
        </div>

        <div className="deity-grid">
          <div className="deity-left" data-aos="zoom-in">
            <div className="gallery-text">
              <h1 style={{ color: "#ab0000" }}>Adhie Annan</h1>
              <p>
                At Adhie Annan temple, the deities bring peace, blessings, and
                protection to all who visit. Each god and goddess represents
                love, wisdom, strength, and prosperity.
              </p>
            </div>
          </div>

          <div className="deity-right">
            <div className="deity-right-top" data-aos="zoom-in">
              <div className="gallery-text">
                <h1>Murugan</h1>
                <p>
                  The deities bring peace, blessings, and protection to all who
                  visit. Each god and goddess represents love, wisdom, strength,
                  and prosperity.
                </p>
              </div>
            </div>

            <div className="deity-right-bottom" data-aos="zoom-in">
              <div className="gallery-text">
                <h1>Vinayagar</h1>
                <p>
                  The deities bring peace, blessings, and protection to all who
                  visit. Each god and goddess represents love, wisdom, strength,
                  and prosperity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
